// import logoDark from 'assets/images/logo-dark.svg';
// import logo from 'assets/images/logos/Logos CardioID/VersaoNegativo_HeartmetricsExperts_RGB.png';
import logo from 'assets/images/logos/ConnectedHeart_Logo_Branco.svg';

// ==============================|| LOGO SVG ||============================== //

function Logo() {
    return <img src={logo} alt="Berry" width="100%" height="100%" />;
}

export default Logo;
